import { LOCAL_STORAGE } from '~/plugins/constants/localStorage';
import { ROUTE } from '~/plugins/constants/route';
import { getLocalStorage } from '~/plugins/functions/localStorage';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const accessToken = getLocalStorage(
    LOCAL_STORAGE.OAUTH_ACCESS_TOKEN
  );
  const router = useRouter();

  console.log('accessToken', accessToken, to.name);
  if (accessToken && to.name === ROUTE.LOGIN.NAME) {
    return navigateTo(ROUTE.HOME.LINK ,{ replace: true });
  } else if (
    !accessToken &&
    to.path !== ROUTE.LOGIN.LINK
    // &&
    // to.path !== ROUTE.REGISTER.LINK
  ) {
    return navigateTo(ROUTE.LOGIN.LINK);
  }
});
